import { render, staticRenderFns } from "./StepperButtons.vue?vue&type=template&id=f1a80248&scoped=true&"
import script from "./StepperButtons.vue?vue&type=script&lang=ts&"
export * from "./StepperButtons.vue?vue&type=script&lang=ts&"
import style0 from "./StepperButtons.vue?vue&type=style&index=0&id=f1a80248&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a80248",
  null
  
)

export default component.exports